/* eslint-disable @typescript-eslint/no-extraneous-class -- needed here */
import type { ColorScheme } from '@unifyapps/defs/types/interface';
import type { CurrentUserDetails } from '@unifyapps/network/generated/models/currentUserDetails';

export class UserHelper {
  static getLocale(userContext: CurrentUserDetails | undefined) {
    return (
      userContext?.user?.locale ??
      (userContext?.user?.customProperties?.locale as string | undefined)
    );
  }

  static getColorScheme(userContext: CurrentUserDetails | undefined) {
    return (userContext?.user?.customProperties?.userPreferences as Record<string, unknown>)
      ?.theme as ColorScheme | undefined;
  }
}
